import SidebarLayout from "../../../../layouts/SidebarLayout";
import sidebar from "../../utils/sidebar";
import { useNavigate } from "react-router-dom";
import { useCallback, useEffect, useMemo, useState } from "react";
import PageSubHeader from "../../../../components/Layouts/PageSubHeader";
import { AgGridReact } from "ag-grid-react";
import DefaultPagination from "../../../../components/Pagination";
import { get } from "../../../../utils/helpers/api";
import ViewDrawer from "./Drawers/View";
import { useTranslation } from "react-i18next";
import { useSettings } from "../../../../context/settings";
import AgGridTable from "../../../../components/Tables/AgGrid";

function StockMovementsPage() {
  const { formatDate } = useSettings();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(20);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [selectedMovement, setSelectedMovement] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const getStockMovements = useCallback(async () => {
    setLoading(true);
    const data = await get(`/inventory/stock-movements?page=${currentPage}&page_size=${pageSize}`);
    if(data?.success) {
      setRowData(data.stock_movements.data);
      setTotalPages(data.stock_movements.last_page);
      setTotalRecords(data.stock_movements.total);
    }
    setLoading(false);
  }, [currentPage, pageSize]);

  useEffect(() => {
    getStockMovements();
  }, [getStockMovements]);

  const columnDefs = useMemo(() => [
    {
      field: 'created_at',
      headerName: t('common.date'),
      flex: 1,
      sortable: true,
      valueFormatter: (p) => formatDate(p.value)
    },
    { field: 'product.name', headerName: t('inventory.product'), flex: 1, sortable: true },
    { field: 'type', headerName: t('common.type'), flex: 1, sortable: true },
    { field: 'quantity', headerName: t('common.quantity'), flex: 1, sortable: true },
    { field: 'previous_stock', headerName: t('inventory.previousStock'), flex: 1, sortable: true },
    { field: 'new_stock', headerName: t('inventory.newStock'), flex: 1, sortable: true },
    { field: 'reference', headerName: t('common.reference'), flex: 1, sortable: true }
  ], [t, formatDate]);

  const defaultColDef = useMemo(() => ({ resizable: true }), []);
  const gridContext = useMemo(() => ({ navigate }), [navigate]);

  const onRowClicked = (event) => {
    setSelectedMovement(event.data);
    setDrawerOpen(true);
  };

  return(
    <SidebarLayout sidebar={sidebar}>
      <div className="page-with-subheader">
        <PageSubHeader title={t('inventory.stockMovement')} onReload={getStockMovements} dataTotal={totalRecords} />

        <div className="subheader-page-content">
          <AgGridTable 
            rowData={rowData}
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            loading={loading}
            context={gridContext}
          />

          <DefaultPagination currentPage={currentPage} totalPages={totalPages} onPageChange={setCurrentPage} />
        </div>
      </div>
      
      <ViewDrawer
        movement={selectedMovement}
        isOpen={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      />
    </SidebarLayout>
  );
}

export default StockMovementsPage;